class SearchInput extends HTMLElement {
    constructor() {
        super();
        this.initialise();
    }

    initialise() {
        this.inputElement = this.querySelector("#searchInput");
        this.matchesElement = this.querySelector("#matches");

        this.interactionEventListeners = [];

        const sendEvent = () => {
            for (let i = 0; i < this.interactionEventListeners.length; i++) {
                const callback = this.interactionEventListeners[i];
                callback(this.inputElement.value.toLowerCase().split(" "));
            }
        };

        if (this.inputElement) {
            this.inputElement.addEventListener("keypress", sendEvent);
            this.inputElement.addEventListener("keyup", sendEvent);
            this.inputElement.addEventListener("change", sendEvent);
            this.inputElement.addEventListener("input", sendEvent);
            // Hide/Show the #matches dropdown according to the focus of the input.
            this.inputElement.addEventListener("focusout", () => {
                if (!this.isMatchesMouseDown) {
                    this.matchesElement.style.display = "none";
                }
            });
            this.inputElement.addEventListener("focusin", () => {
                this.inputElement.dispatchEvent(new Event("select"));
                if (this.inputElement.value !== "") {
                    this.matchesElement.style.display = "block";
                }
            });
        }

    }

    // region: Public Functions

    /**
     * addInteractionEventListener
     * @description Add an event Listener for the Interaction event of the search input.
     * @param {Function(terms[])} callback Function to be called when the search input is interacted with.
     *                                     Calls the function with an array of search terms.
     */
    addInteractionEventListener(callback) {
        if (!this.interactionEventListeners.includes(callback)) {
            this.interactionEventListeners.push(callback);
        }
    }

    /**
     * showResults
     * @description Shows the results dropdown with the given list of results.
     * @param {string[]} resultList list of items to display in the results dropdown of the search input
     * @param {Function(string)} clickCallback Callback function to be called when an item is clicked in the dropdown.
     *                                          Calls the function with the clicked item.
     */
    showResults(resultList, clickCallback) {
        // Turn the #matches dropdown off/on according to the number of search results.
        this.matchesElement.style.display = resultList.length > 0 ? "block" : "none";

        // Clear #matches dropdown.
        this.matchesElement.innerHTML = "";

        // Populate #matches dropdown
        for (let i = 0; i < resultList.length; i++) {
            const result = resultList[i];
            const div = document.createElement("div");
            div.classList.add("result-item");
            div.innerHTML = result;
            div.addEventListener("mousedown", () => {
                this.isMatchesMouseDown = true;
            });
            div.addEventListener("mouseup", () => {
                if (this.isMatchesMouseDown) {
                    setTimeout(() => {
                        this.matchesElement.style.display = "none";
                    }, 100);

                    clickCallback(div.innerHTML);
                    this.inputElement.value = "";
                }
                this.isMatchesMouseDown = false;
            });
            this.matchesElement.appendChild(div);
        }
    }

    clear() {
        this.inputElement.value = "";
    }
}

if (!customElements.get("search-input")) {
    customElements.define("search-input", SearchInput);
}
